import {
  Image,
  ImageSourcePropType,
  ImageStyle,
  StyleProp,
} from "react-native";

// images stored in DO have these sizes
// https://cuanto-flags.sfo2.cdn.digitaloceanspaces.com/costarica.jpeg

// apparently flags come in all kinds of aspect ratios, and most are fine-ish
// https://en.wikipedia.org/wiki/List_of_aspect_ratios_of_national_flags
const DO_FLAG_HEIGHT = 60;
const DO_FLAG_WIDTH = 84;

type Props = {
  source: ImageSourcePropType;
  scale?: number;
  style?: StyleProp<ImageStyle>;
};

export default function Flag({ source, scale = 1, style }: Props) {
  const height = DO_FLAG_HEIGHT * scale;
  const width = DO_FLAG_WIDTH * scale;

  return <Image source={source} style={[{ height, width }, style]} />;
}
